<template>
  <label :class="componentClasses">
    <slot>{{ label }}</slot>
  </label>
</template>

<script>
export default {
  props: {
    align: {
      type: String,
      default: null,
      validator: (value) => {
        const alignments = ['left', 'center', 'right']
        return alignments.includes(value)
      },
    },
    label: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      axComponentClass: 'ax--label',
    }
  },
  computed: {
    componentClasses() {
      let classList = [`${this.axComponentClass}`]
      if (this.align) {
        classList.push(`${this.axComponentClass}--${this.align}`)
      }

      return classList.join(' ')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../Content/scss/config';

.ax--label {
  color: $color-label;
  display: block;
  text-transform: uppercase;
  line-height: 3; // A standard font size (16px) equates to 48px toll for this label. assumes no line wrapping
  font-size: pxrem(16);

  &--center {
    text-align: center;
    justify-content: center;
  }

  &--lowercase {
    text-transform: lowercase;
  }

  &--error {
    color: #d70000;
  }

  span {
    float: right;
  }
}
</style>
